import { DOCUMENT } from '@angular/common';
import { Injectable, Inject } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class SEOService {
    constructor(@Inject(DOCUMENT) private dom: Document) {}

    createCanonicalURL(url?: string) {
        let canURL = url === undefined ? this.dom.URL : url;
        if (canURL.endsWith('homepage')) {
            canURL = canURL.replace('homepage', '');
        }
        const matchProtocolDomainHost = /^.*\/\/[^\/]+:?[0-9]?\//i;
        if (canURL.replace(matchProtocolDomainHost, '') !== '') {
            if (canURL.replace(matchProtocolDomainHost, '').startsWith('/')) {
                canURL = `${environment.canonicalBaseAddress}${canURL.replace(matchProtocolDomainHost, '')}`;
            } else {
                canURL = `${environment.canonicalBaseAddress}/${canURL.replace(matchProtocolDomainHost, '')}`;
            }

        } else {
            canURL = `${environment.canonicalBaseAddress}`;
        }
        const link: HTMLLinkElement = this.dom.createElement('link');
        link.setAttribute('rel', 'canonical');
        this.dom.head.appendChild(link);
        link.setAttribute('href', canURL);
    }
}
